import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_URL+'/PromoCode';
// Create axios instance
const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const promoCodeValidationService = {
  // Check if promo code exists and is valid
  checkPromoCode: async (code) => {
    try {
      const response = await api.get(`/CheckCode?code=${encodeURIComponent(code)}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Code promo invalide'
      };
    }
  },

  incrementPromoCodeUsage: async (promoCodeData) => {
    try {
      console.log('Incrementing usage for promo code:', promoCodeData);
      
      // Make sure we have the ID
      if (!promoCodeData.id) {
        throw new Error('Promo code ID is required for updating usage');
      }
      
      const updatedData = {
        ...promoCodeData,
        updatedDatetime: new Date().toISOString()
      };
      
      console.log('Updated data to send:', updatedData);
      
      // FIXED: Include the ID in the URL path
      const response = await api.put(`/${promoCodeData.id}`, updatedData);
      
      console.log('Successfully updated promo code usage');
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
      console.error('Error incrementing promo code usage:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Erreur lors de la mise à jour du code promo'
      };
    }
  }
};